// extracted by mini-css-extract-plugin
module.exports = {"partScoreAndNarrative":"style-module__partScoreAndNarrative___10LXE","detractor":"style-module__detractor___34GRR","promoter":"style-module__promoter___27lhT"};